<template>
  <div id="baojiawrap">
    <div v-show="!hideLeft" :style="{ width: width + 'px' }" id="baojiawrapLeft">
      <topSelect @now="reachNow" :data="items123" @on-change="topchange"></topSelect> <!-- 收货送货类 -->
    </div>
    <div :style="{ width: 'calc(100% - ' + width + 'px)' }" ref="baojiawrapRight" id="baojiawrapRight">
      <danjia ref="danjia" :data="items123.danjia" v-show="items123.danjia.select"></danjia>
      <danjia2 ref="danjia2" :data="items123.danjia2" v-show="items123.danjia2.select"></danjia2>
      <!-- 拼车类 -->
      <pinche ref="pinche" :data="items123.pinche" v-show="items123.pinche.select">
      </pinche>
      <!-- 专车类 -->
      <zhuanche ref="zhuanche" :data="items123.zhuanche" v-show="items123.zhuanche.select"></zhuanche>
      <zhuanche2 ref="zhuanche2" :data="items123.zhuanche2" v-show="items123.zhuanche2.select"></zhuanche2>

      <!-- 装卸费 -->
      <zhuangXie ref="zhuangXie" :data="items123.zhuangXie" v-show="items123.zhuangXie.select"></zhuangXie>
      <zhuangXie2 ref="zhuangXie2" :data="items123.zhuangXie2" v-show="items123.zhuangXie2.select"></zhuangXie2>
      <!-- 大陆收货送货 -->
      <shouHuoSongHuo ref="shouHuoSongHuo" :data="items123.shouHuoSongHuo" v-show="items123.shouHuoSongHuo.select">
      </shouHuoSongHuo>
      <!-- 苦力类 -->
      <kuli id="kuli111" ref="kuli" :data="items123.kuli" v-show="items123.kuli.select">
      </kuli>

      <guoBan ref="guoBan" :data="items123.guoBan" v-show="items123.guoBan.select"></guoBan>

      <!-- 报关类 -->
      <baoguan ref="baoguan" :data="items123.baoguan" v-show="items123.baoguan.select"></baoguan>
      <other ref="other" :data="items123.other" v-show="items123.other.select"></other>


    </div>

  </div>
</template>
<script>

import topSelect from "./baojia/topSelect.vue";
import modelData from "./baojia/modelData";


import baoguan from "./baojias/baoguan.vue";
import other from "./baojias/other.vue";
import zhuangXie from "./baojias/zhuangXie.vue";
import zhuangXie2 from "./baojias/zhuangXie2.vue";
import shouHuoSongHuo from "./baojias/shouHuoSongHuo.vue";
import danjia from "./baojias/danjia.vue";
import danjia2 from "./baojias/danjia2.vue";
import pinche from "./baojias/pinche.vue";
import zhuanche from "./baojias/zhuanche.vue";
import zhuanche2 from "./baojias/zhuanche2.vue";
import kuli from "./baojias/kuli.vue";
import guoBan from "./baojias/guoBan.vue";

export default {
  components: {
    topSelect,
    baoguan,
    other,
    zhuangXie,
    zhuangXie2,
    shouHuoSongHuo,
    danjia,
    danjia2,
    pinche,
    zhuanche,
    zhuanche2,
    kuli,
    guoBan
  },
  //props: ["items"],
  data() {
    return {
      width: 240,
      hideLeft:false,
      items123: {
        danjia: {
          name: "单价运输费",
          title: "中港拼车（单价计费）",
          currency: '人民币',
          select: false,
          type: 1, //大类，1--运输  2--苦力  3--其他
          formula: 1, //计算公式(有可能同一个底层数据有不同的计算公式)
          startPirce: 0,
          startPirceIn: 0,
          function: "danjiaPrice(0,0)",
          partPrice: {
            //散货的
            kgs: 0, //重量单价
            cbm: 0,
            pl: 0,
            ctn: 0,
            startPirce: 0, //起步价
          },
          list: [
            modelData.danjiaModel
          ],
        },
        danjia2: {
          name: "单价运输费",
          currency: '人民币',
          select: false,
          type: 1,
          formula: 1,
          startPirce: 0,
          startPirceIn: 0,
          function: "pinchePrice(0,0)",
          bulkPrice: { startPirce: 0, pl: 0, kgs: 0, cbm: 0, ctn: 0 },//散货计费
          list: [
            modelData.danjiaModel2
          ],
          //max(qujian('kgs','cbm','pl','ctn')) //区间取大
        },
        pinche: {
          name: "拼车费",
          currency: '人民币',
          select: false,
          type: 1,
          formula: 1,
          startPirce: 0,
          startPirceIn: 0,
          function: "pinchePrice(0,0)",
          bulkPrice: { startPirce: 0, pl: 0, kgs: 0, cbm: 0, ctn: 0 },//散货计费
          list: [
            modelData.pincheModel
          ],
          //max(qujian('kgs','cbm','pl','ctn')) //区间取大
        },
        zhuanche: {
          name: "中港运输专车费",
          currency: '人民币',
          select: false,
          type: 0,
          formula: 1,
          startPirce: 0,
          startPirceIn: 0,
          function: "zhuanchePrice(0,0)",
          type: 1,
          list: [
            modelData.zhuancheModel
          ],
        },
        zhuanche2: {
          name: "中港运输专车费",
          currency: '人民币',
          select: false,
          type: 0,
          formula: 1,
          startPirce: 0,
          startPirceIn: 0,
          function: "zhuanchePrice(0,0)",
          type: 1,
          list: [
            modelData.zhuancheModel2
          ],
        },
        zhuangXie: {
          name: "装卸费",
          currency: '人民币',
          select: false,
          type: 1, //大类，1--运输  2--苦力  3--其他
          formula: 1, //计算公式(有可能同一个底层数据有不同的计算公式)
          startPirce: 0,
          partPrice: {
            //散货的
            kgs: 0, //重量单价
            cbm: 0,
            pl: 0,
            ctn: 0,
            startPirce: 0, //起步价
          },
          list: [
            modelData.zhuangxieModel2
          ],
        },
        zhuangXie2: {
          name: "装卸费",
          currency: '人民币',
          select: false,
          type: 1,
          formula: 1,
          startPirce: 0,
          startPirceIn: 0,
          function: "pinchePrice(0,0)",
          bulkPrice: { startPirce: 0, pl: 0, kgs: 0, cbm: 0, ctn: 0 },//散货计费
          list: [
            modelData.zhuangxieModel2
          ],
          //max(qujian('kgs','cbm','pl','ctn')) //区间取大
        },

        shouHuoSongHuo: {
          name: "大陆提货/送货费",
          currency: '人民币',
          startPirce: 0,
          handlingPrice: {
            //装卸费
            startPirce: 0,
            pl: 0,
            kgs: 0,
            cbm: 0,
            ctn: 0,
          },
          select: false,
          type: 1,
          list: [modelData.shouHuoSongHuoModel],
          functionList: []
        },
        kuli: {
          select: false,
          name: "香港提货/送货费",
          currency: '人民币',
          startPirce: 0,
          startPirceIn: 0,
          formula: 1,
          mainFormula: 1,
          function: "kuliPrice(0,0)",
          outRange: { kgsCz1: 0, cbmCz1: 0, kgsCz2: 0, cbmCz2: 0, cbmCz3: 0 },
          partPrice: { kgs: 0, cbm: 0, ctn: 0 },
          bulkPrice: { startPirce: 0, pl: 0, kgs: 0, cbm: 0, ctn: 0 },
          guobanPrice: { startPirce: 0, pl: 0, kgs: 0, cbm: 0, ctn: 0 },//散货计费
          list: [
            {
              name: "每件价格",
              tag: "CTN",
              unit: ["KGS", "CBM"],
              list: [
                {
                  name: "0-50,10-20",
                  unit: ["0-2", "0-2"],
                  price: 0,
                },
                {
                  name: "50-100,30-40",
                  unit: ["50-100", "30-40"],
                  price: 0,
                },
              ],
            },
            {
              name: "每板价格",
              tag: "P/L",
              unit: ["KGS", "CBM"],
              list: [
                {
                  name: "0-50,10-20",
                  unit: ["0-2", "0-2"],
                  price: 0,
                },
                {
                  name: "50-100,30-40",
                  unit: ["50-100", "30-40"],
                  price: 0,
                },
              ],
            },
          ],
        },
        guoBan: {
          name: "过板费",
          title: "",
          currency: '人民币',
          select: false,
          type: 1, //大类，1--运输  2--苦力  3--其他
          formula: 1, //计算公式(有可能同一个底层数据有不同的计算公式)
          startPirce: 0,
          startPirceIn: 0,
          function: "",
          partPrice: {
            //散货的
            kgs: 0, //重量单价
            cbm: 0,
            pl: 0,
            ctn: 0,
            startPirce: 0, //起步价
          },
          list: [
            modelData.guoBanModel
          ],
        },
        baoguan: {
          name: "报关费",
          title: "报关费",
          currency: '人民币',
          select: false,
          type: 1, //大类，1--运输  2--苦力  3--其他
          formula: 1, //计算公式(有可能同一个底层数据有不同的计算公式)
          startPirce: 0,
          partPrice: {
            //散货的
            kgs: 0, //重量单价
            cbm: 0,
            pl: 0,
            ctn: 0,
            startPirce: 0, //起步价
          },
          list: [
            modelData.baoguanModel
          ],
        },
        other: {
          name: "其他费",
          currency: '人民币',
          type: 3,
          select: false,
          list: [],
        },
        /*  common: {
           name: "附加项目",
           currency: '人民币',
           type: 3,
           select: true,
           list: [{
             name: '顺风车',
             function: "shunFengChe(0,'人民币')"
           },
           {
             name: '打转',
             function:"daZhuan(0,'人民币')"
           },
           ],
         }, */
      },
      items12: {},
      flist: [],

      danjiaModel: modelData.danjiaModel,
      danjiaModel2: modelData.danjiaModel2,
      zhuangxieModel: modelData.zhuangxieModel,
      zhuangxieModel2: modelData.zhuangxieModel2,
      pincheModel: modelData.pincheModel,
      zhuancheModel: modelData.zhuancheModel,
      kuliModel: modelData.kuliModel,
      shouHuoSongHuoModel: modelData.shouHuoSongHuoModel,
      openHelp: false,
      helps: [],
      unitTime: null, //用来防抖
      units: [
        {
          name: "KGS",
          select: true,
        },
        {
          name: "CBM",
          select: true,
        },
        {
          name: "P/L",
          select: true,
        },
      ],
      danjias: [
        {
          name: "KGS",
          select: true,
        },
        {
          name: "CBM",
          select: true,
        },
        {
          name: "件",
          select: true,
        },
        {
          name: "P/L",
          select: true,
        },
      ],
      kulis: [
        [
          {
            name: "KGS",
            select: true,
          },
          {
            name: "CBM",
            select: true,
          },
        ],
        [
          {
            name: "KGS",
            select: true,
          },
          {
            name: "CBM",
            select: true,
          },
        ],
      ],
      zidian: modelData.zidian

    };
  },
  methods: {
    //顶部改变
    topchange(v, index) {
      this.items123[index].select = v.select;
      if (v.select) {
        setTimeout(() => {
          this.scroll(index)
        }, 500);

      }
    },

    reach(v) {
     
      if (this.utils.isEmpty(v)) {
        //收费项目

      } else {
        for (const i in v) {
          if (v[i] == null) {
            v[i] = this.items123[i];
          }
          for (const j in v[i]) {
            if (v[i][j] == null) {
              v[i][j] = this.items123[i][j];
            }
          }
          // this.items123[i].title = this.zidian[this.items123[i].name];
        }
        this.items123 = v;

      }
    },
    getVal() {
      var t = this.items123;
      //delete t.common;
      //delete t.zhuanche2;
      for (const i in t) {
        if (t[i] != null) {
          t[i] = this.$refs[i].getVal();
        }

      }
      return this.items123;
    },
    //展开和收起
    reachNow(v) {
      if (v) {
        this.width = 240;
      } else {
        this.width = 0;
      }
    },
    //滚动
    scroll(index) {
      const tbody = this.$refs.baojiawrapRight;
      var a = this.$refs[index].$el.offsetTop;
      //tbody.scrollTop = a - 50;
      tbody.scrollTo({
        top: a - 70,
        behavior: "smooth",
      });
    },
  },
  mounted() {
    //this.getFlist();
  },
  model: {
    prop: "items",
  },
  watch: {
    items(v) {
      //this.getFlist();
    },
  },
};
</script>
<style>
#baojiawrap {
  display: flex;
  height: calc(100% - 50px);

}

#baojiawrapLeft {
  margin-right: 4px;
  height: 100%;
}

#baojiawrapRight {
  height: 100%;
  overflow: auto;
}

#itemList {
  margin-bottom: 20px;
}

.priceTable {
  display: flex;
  width: 100%;
  overflow: auto;
}

#itemList .fenleibiaoti {
  display: flex;
}

#itemList h4 {
  font-weight: bold;
  margin-bottom: 6px;
}

.priceTable>div {
  flex: 1;
  border: solid#82a0f9;
  border-width: 3px 0px 0px 0;
  min-width: 120px;
}



.priceTable>div>p {
  border-bottom: 1px solid #333;
  padding: 0 6px;
  min-height: 28px;
  line-height: 24px;
}

.priceTable>div>p:nth-child(2) {
  border-bottom: 3px solid #82a0f9;

}

.baojiatitle {
  display: flex;
  padding: 4px 8px 8px 8px;
  margin-bottom: 12px;
  background: linear-gradient(to right, #8a8ae7, #bfcfdc);
  color: #fff;
}

.baojiatitle h3 {
  font-size: 20px;
  margin-top: 4px;
  margin-right: 30px;
  position: relative;
  left: 16px;
}

.baojiatitle h3::before {
  content: "";
  width: 6px;
  height: 20px;
  position: absolute;
  background: #fff;
  left: -16px;
  top: 0;
}

.ananan {
  display: flex;
  margin-left: auto;
}

.ananan li {
  padding: 4px 10px;
  border: solid 2px #e2dfdf;
  margin-left: 10px;
  cursor: pointer;
}

.ananan li.active {
  border: solid 2px #1e84e4;
}
</style>


// WEBPACK FOOTER //
// src/components/wuliu/kehu/baojia.vue